import { db } from 'boot/firebase';
import { collection, collectionGroup, getDocs, limit, query, where } from 'firebase/firestore';

import GenericDB from './generic-db';

export default class ProgramFilesDB extends GenericDB {
  constructor(programId = null) {
    super('', 'programs.programFiles');
    this.setProgramId(programId);
  }

  setProgramId(programId) {
    this.programId = programId;
  }

  getCollectionRef() {
    return collection(db, 'programs', this.programId, 'programFiles');
  }

  // eslint-disable-next-line class-methods-use-this
  async findFileByField(field, value, limitQuery = null) {
    let queryBuilder = collectionGroup(db, 'programFiles');
    queryBuilder = query(queryBuilder, where(field, '==', value));

    if (limitQuery) {
      queryBuilder = query(queryBuilder, limit(limitQuery));
    }

    const res = await getDocs(queryBuilder);

    if (res.empty) {
      return [];
    }

    return res.docs.map((ref) => ({
      ...ref.data(),
      id: ref.id,
    }));
  } // findFileByField
}
